import React from 'react';
import { Modal, IconButton, Box, Typography, Button } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import DownloadIcon from '@mui/icons-material/Download';
import { styled } from '@mui/system';
import { StyledButton } from '../buttons/custom-button';
import { CloseButton, FooterContainer } from './custom-popup';

export interface ActionButtonConfig {
  label: string;
  onClick: () => void;
  variant?: 'text' | 'outlined' | 'contained';
  color?: 'inherit' | 'primary' | 'secondary' | 'default';
  disabled?: boolean;
}

interface ModalPopupProps {
  open: boolean;
  onClose: () => void;
  title?: string;
  children: React.ReactNode;
  actions?: ActionButtonConfig[];
  onDownload?: () => void;
}
export const StyledModal = styled(Modal)(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    margin:'2rem 2rem 2rem 2rem'
  }));
  
  // Custom Styled Box to act as the Modal Container
  export const ModalContainer = styled(Box)(({ theme }) => ({
    position: 'relative',
    backgroundColor: '#FFFFFF',
    padding: theme.spacing(4) ,
    paddingBottom:"0 !important",
    borderRadius: '4px',
    // boxShadow: theme.shadows[5],
    outline: 'none',
    maxWidth: '100%', 
    minHeight: '100%',
    maxHeight: '100%',
    width: '100%',
    overflowY: 'auto', 
    boxSizing: 'border-box',
    scrollBehavior: 'smooth',
    display: 'flex',
    flexDirection: 'column',
    [theme.breakpoints.down('sm')]: {
      width: '100%', 
    },
    '&::-webkit-scrollbar': {
      width: '6px',
      background: 'transparent',
    },
    '&::-webkit-scrollbar-thumb': {
      backgroundColor: '#ccc',
      borderRadius: '3px',
    },
    '&::-webkit-scrollbar-track': {
      background: 'transparent',
    },
  }));

const ViewerModalPopup: React.FC<ModalPopupProps> = ({ open, onClose, title, children, actions = [], onDownload }) => {
  return (
    <StyledModal open={open} onClose={onClose} aria-labelledby="modal-title" role="dialog">
      <ModalContainer>
        <CloseButton onClick={onClose} aria-label="Close">
          <CloseIcon />
        </CloseButton>

        <Box display="flex" justifyContent="space-between" alignItems="center" mb={2} pr={6}>
          {title ? (
            <Typography variant="h6" id="modal-title" style={{ margin: 0 }}>
              {title}
            </Typography>
          ) : (
            <div />
          )}
          {onDownload && (
            <StyledButton
              onClick={onDownload}
              variant="contained"
            >
              Download PDF
            </StyledButton>
          )}
        </Box>

        <Box flex="1" style={{ height: 'calc(100% - 60px)' }}>{children}</Box>

        <FooterContainer>
          {actions.map((action, index) => (
            <StyledButton
              key={index}
              onClick={action.onClick}
              variant={action.variant || 'text'}
            //   color={action.color || 'primary'}
              disabled={action.disabled}
            >
              {action.label}
            </StyledButton>
          ))}
        </FooterContainer>
      </ModalContainer>
    </StyledModal>
  );
};

export default ViewerModalPopup;
